import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material';

export default function SectionStructureBlood(props) {

    const theme = useTheme()
    const {sectiontext, sectionsubtext, sectionref, sectioncards} = props

return (
    <>
<Grid container>

{/* Header Section */}   
<Grid size={12}> 
<Grid container spacing={1} 
        sx={{
            mx: {xs: 4, xl:24},
            my: {xs: 4, xl:8},
            px:4,
            py:2,  
            bgcolor: theme.palette.mode === "light" ? 'grey.C100' : 'greydark.C970', borderRadius: '12px', }}>
                    <Grid size={{sm: 12}}> {sectiontext} </Grid>
                    <Grid size={{sm: 12,}}> {sectionsubtext} </Grid>
                    <Grid size={{sm: 12}}> {sectionref} </Grid>
               
            </Grid>
         </Grid>

{/* Main, Cards */}   
<Grid size={12} sx={{mt:2, mb:8}}> {sectioncards}</Grid>

   </Grid>

</>
)
}